import { ColorPicker, GetProp } from 'antd';
import { IColorPickerProps } from './entities/IColorPickerProps';

export type OnColorChangeComplete = GetProp<typeof ColorPicker, 'onChangeComplete'>;

const BCColorPicker = (props: IColorPickerProps) => <ColorPicker {...props} />;

export default BCColorPicker;
